<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Empresa</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="form-group col-md-5">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="empresa.nome" placeholder="" />
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Email">
                        <span class="required">*</span> Nome Fantasia:
                      </label>
                      <input autocomplete="new-password" class="form-control" id="Email" placeholder="" type="text"
                        v-model="empresa.nome_fantasia" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Cellphone"><span class="required">*</span> CNPJ:</label>
                      <input autocomplete="new-password" class="form-control" id="Email" placeholder="" type="text"
                        v-model="empresa.cnpj" v-mask="'99.999.999/9999-99'" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Cellphone"><span class="required">*</span> CNES:</label>
                      <input autocomplete="new-password" class="form-control" id="Cellphone" type="text"
                        v-model="empresa.cnes" placeholder="" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="Phone"><span class="required">*</span> CEP:</label>
                      <input autocomplete="new-password" type="text" class="form-control" id="Phone"
                        v-model="empresa.cep" v-mask="'99999-999'" placeholder="" @input="buscar" />
                    </div>
                    <div class="form-group col-md-5">
                      <label for="inputUser">
                        <span class="required">*</span> Logradouro:
                      </label>
                      <input autocomplete="new-password" class="form-control" id="Email" placeholder="" type="text"
                        v-model="empresa.logradouro" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="inputUser">
                        <span class="required">*</span> Número:
                      </label>
                      <input autocomplete="new-password" class="form-control" id="inputNumero" placeholder=""
                        type="text" v-model="empresa.numero" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="inputUser">
                        <span class="required">*</span> Bairro:
                      </label>
                      <input autocomplete="new-password" class="form-control" id="Email" placeholder="" type="text"
                        v-model="empresa.bairro" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="inputUser">
                        <span class="required">*</span> Cidade:
                      </label>
                      <input autocomplete="new-password" class="form-control" id="Email" placeholder="" type="text"
                        v-model="empresa.cidade" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="inputUser">
                        <span class="required"></span> Complemento:
                      </label>
                      <input autocomplete="new-password" class="form-control" id="Email" placeholder="" type="text"
                        v-model="empresa.complemento" />
                    </div>
                    <div class="form-group col-md-1">
                      <label for="inputUser">
                        <span class="required">*</span> UF:
                      </label>
                      <input autocomplete="new-password" class="form-control" id="Email" placeholder="" type="text"
                        v-model="empresa.uf" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="password">
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="empresa.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group">
                    <div class="block text-right">
                      <router-link to="/empresas" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      departments: [],
      change_password: true,
      empresa: {
        cep: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        uf: '',
        status: '1'
      },

      errors: undefined,

      previewImage: null,
    };
  },
  computed: {},
  methods: {

    save: function () {
      const self = this;
      let api = self.$store.state.api + "empresas";

      if (self.empresa.id) {
        self.empresa._method = "PUT"
        api += "/" + self.empresa.id;
      }

      axios
        .post(api, self.empresa)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/empresas");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.empresa.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.empresa.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.empresa.logradouro = self.endereco.logradouro;
            self.empresa.bairro = self.endereco.bairro;
            self.empresa.uf = self.endereco.uf;
            self.empresa.cidade = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getEmpresa: function (id) {
      const self = this;
      const api = self.$store.state.api + "empresas/" + id;

      axios
        .get(api)
        .then((response) => {
          self.empresa = response.data.data[0];

        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getEmpresa(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>